import styled from 'styled-components';

export const StyledPaginationWrapper = styled.div`
  display: flex;
  align-items: center;

  .pagination {
    display: flex;
    align-items: center;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;

    li a {
      min-width: 30px;
      height: 30px;
      padding: 0 8px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: var(--r-sm);
      border: 1px solid var(--line);
      background: var(--surface);
      color: var(--ink-2);
      font-family: inherit;
      font-size: var(--t-sm);
      font-weight: 500;
      font-variant-numeric: tabular-nums;
      cursor: pointer;
      text-decoration: none;
      transition: background var(--dur-fast) var(--ease-out),
        border-color var(--dur-fast) var(--ease-out),
        color var(--dur-fast) var(--ease-out);

      &:hover {
        background: var(--paper-2);
        border-color: var(--brand-green);
        color: var(--ink);
      }
    }

    li.active a {
      background: var(--brand-ink);
      border-color: var(--brand-ink);
      color: var(--surface);
      font-weight: 700;

      &:hover {
        background: var(--brand-ink);
        border-color: var(--brand-ink);
        color: var(--surface);
      }
    }

    li.disabled a {
      opacity: 0.3;
      pointer-events: none;
    }

    li.separator a {
      border: none;
      background: transparent;
      color: var(--muted-2);
      min-width: auto;
      padding: 0 4px;
      cursor: default;

      &:hover {
        background: transparent;
        border: none;
        color: var(--muted-2);
      }
    }

    li.previous a,
    li.next a {
      svg {
        width: 14px;
        height: 14px;
        fill: none;
        stroke: currentColor;
      }
    }
  }
`;
